import { gql } from '@apollo/client';

import { LessonMaterialFragment } from './lesson-material-fragment';

export const GET_LESSON_MATERIALS = gql`
  query GetLessonMaterials($input: GetLessonMaterialsInput!) {
    getLessonMaterials(input: $input) {
      id
      component {
        index
      }
      lessonMaterials {
        ...LessonMaterialFragment
      }
    }
  }
  ${LessonMaterialFragment}
`;
